<template>
  <div v-if="canShowEndPromoButton">
    <v-btn v-if="!value" color="error" :loading="sendMessageLoading" @click="buttonAction()">
      Finir la campagne
    </v-btn>
    <div v-else>
      Campagne terminée le {{ dateFormatted }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue';
import gql from 'graphql-tag';
import { useMutation } from '@vue/apollo-composable';
import { useStore } from 'vue2-helpers/vuex';
import moment from 'moment';
import { EventBus } from '../../../mixins';

const store = useStore();
const emit = defineEmits(['input']);
const props = defineProps({
  value: {
    type: Number,
    default: null
  },
  field: {
    type: Object,
    default: () => null
  },
  formContent: {
    type: Object,
    default: () => null
  }
});

const dateFormatted = computed(() => {
  if (!props.value) return null;
  return moment(props.value).format('DD/MM/YYYY à HH:mm');
});

const uuid = computed(() => props.formContent?.uuid);

const promoEnded = ref(false);

const canShowEndPromoButton = computed(() => props.formContent?.online && props.formContent?.status === 'published');

const { mutate: endPromo, loading: sendMessageLoading } = useMutation(
  gql`mutation alphaEndPromotionalCampaign($uuid: String!, $workspace: String!) {
      alphaEndPromotionalCampaign(uuid: $uuid, workspace: $workspace) {
        success
        data
        message
      }
    }`,
  () => ({
    variables: {
      uuid: uuid.value,
      workspace: store.getters.workspace.code
    }
  })
);

const buttonAction = async () => {
  promoEnded.value = await endPromo().then(res => {
    if (res.data.alphaEndPromotionalCampaign.success) {
      const text = 'Promotional campaign ended successfully';
      const options = {
        timeout: 5000,
        type: 'success'
      };
      console.log('Promotional campaign ended successfully');
      EventBus.$emit('show-notification', { text, options });
      return res.data.alphaEndPromotionalCampaign.data.endPromotionCampaignTimestamp;
    }

    const text = 'Error ending promotional campaign';
    const options = {
      timeout: 5000,
      type: 'error'
    };

    EventBus.$emit('show-notification', { text, options });
    return null;
  });
};

watch(promoEnded, () => {
  emit('input', promoEnded.value);
});
</script>
